import { render, staticRenderFns } from "./VipVoucher.vue?vue&type=template&id=0aa43974&scoped=true&"
import script from "./VipVoucher.vue?vue&type=script&lang=js&"
export * from "./VipVoucher.vue?vue&type=script&lang=js&"
import style0 from "./VipVoucher.vue?vue&type=style&index=0&id=0aa43974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa43974",
  null
  
)

export default component.exports